<template>
  <HModal
    :visible="true"
    :show-close="false"
  >
    <drag-header />
    <div class="pop-wrap new-pay">
      <a
        @click="closeModal"
        class="btn_close"
        data-et-click
      />
      <div class="act-hd sprite-diamond-spring-act sprite-diamond-spring-act-header-bg">
        <i class="sprite-icon sprite-icon-home-logo" /><span class="title">PDF-会员续费</span>
      </div>
      <div class="act-bd">
        <div class="item account-item">
          会员账号：<span class="name-style">{{ userInfo ? userInfo.nickname : '' }}</span>
          <LoginFromIcon :type="userInfo.login_frm" />
        </div>
        <div class="item account-item">
          <div class="item-lt">
            会员到期时间：
          </div>
          <div class="item-rt">
            {{ pdfPermissionVipInfo.vip_ex_date | dateFilter }}
          </div>
        </div>
        <div class="item account-item">
          <div class="item-lt">
            续费后到期时间：
          </div>
          <div class="item-rt">
            {{ filterDate(pdfPermissionVipInfo.vip_ex_date + curSetting.service_duration_secs) }}
          </div>
        </div>
        <div
          v-if="settingsShow"
          class="pay-setting"
        >
          <div class="item pay-setting-item">
            <div class="item-rt">
              <div class="pay-list">
                <ul>
                  <li
                    v-for="(i, idx) in settingsShow"
                    :key="i.id"
                    class="pay-item"
                  >
                    <div
                      :class="{
                        active: isActive === idx,
                      }"
                      @click="selPrice(idx, i.id, i)"
                    >
                      <!-- 默认 默认文案小标 1什么都不展示 2倒计时 3图片 -->
                      <span v-if="i.title_type === 1" />
                      <span
                        v-else-if="!i.title_type && i.title"
                        class="tit sprite-icon sprite-icon-pay-title"
                      >{{ i.title }}</span>
                      <div
                        v-else-if="i.title_type === 3 && i.title_img"
                        class="tit-img-3"
                      >
                        <img :src="i.title_img">
                      </div>
                      <div
                        v-else-if="i.title_img"
                        class="tit-img-4"
                      >
                        <img :src="i.title_img">
                      </div>
                      <!-- end 默认 默认文案小标 1什么都不展示 2倒计时 3图片 -->
                      <p class="current-price">
                        <em>￥</em>{{ i.current_price }}
                      </p>
                      <p class="time-line">
                        {{ i.description }}
                      </p>
                      <div class="linear" />
                      <p
                        :class="tipClass[i.bottom_type]"
                        class="tip"
                      >
                        {{ i.bottom }}
                      </p>
                      <em class="active-hook" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 优惠券 -->
          <div
            v-if="coupons && coupons.length"
            class="coupon-list"
          >
            <div
              v-for="(coupon, index) in coupons"
              :key="coupon.couponID"
              :class="{ active: activatedCouponID === coupon.couponID }"
              @click="clickCoupon(coupon, index)"
              class="coupon-item"
            >
              <div class="coupon-left">
                <span class="coupon-price">
                  {{ coupon.coupon }}
                  <img
                    class="coupon-unit"
                    src="./_images/coupon-unit.png"
                  >
                </span>
              </div>

              <div class="coupon-right">
                <span class="coupon-title">{{ getCouponContent(coupon.month_length) }}</span>
                <img
                  v-if="activatedCouponID === coupon.couponID"
                  class="coupon-button"
                  src="./_images/button-cancel.png"
                >
                <img
                  v-else
                  class="coupon-button"
                  src="./_images/button-confirm.png"
                >
              </div>
            </div>
          </div>
          <div class="item qrcode-item">
            <div class="item-rt">
              <dl class="pay_type">
                <dd>
                  <span
                    class="wechatpay sprite-icon sprite-icon-wechatpay"
                  />
                </dd>
              </dl>
              <div class="qrcode">
                <img
                  v-if="!loginStatus || isExpires || !qrText"
                  @click="login(9)"
                  src="@/assets/images/qrcode.png"
                  alt
                >
                <qrcode-vue
                  v-else
                  :value="qrText"
                  :size="110"
                  level="H"
                />
              </div>
              <div class="pay-price">
                <p class="current-price">
                  <em>￥</em>{{ total }}
                </p>
                <p class="pay-title">
                  使用<em>微信</em>APP扫码完成支付
                </p>
                <p class="pay-title">
                  开通会员可开发票
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </HModal>
</template>

<script>
import Cookie from 'js-cookie'
import QrcodeVue from 'qrcode.vue'
import { mapGetters, mapActions } from 'vuex'
import LoginFromIcon from '@/components/common/LoginFromIcon'
import client from '@/client/'
import { getPaySetting, getH5PayResult, cacheH5PageReportParams, getPayQrcode } from '@/api/pdfPay'
import { getCouponConfig } from '@/api/coupon'
import { LOGIN_SERVICE, REPORT_RELATED, UNI_FROM, PAY_CHANNEL, PAY_TYPE } from '@/config/dataMap'
import DragHeader from '@/components/common/DragHeader'
import { dateFilter } from '@/filters/index'
import common from '@/client/modules/common.js'
import { LS_EVENT } from '@/utils/localStorage'
import { genMidasPayUrl, getCommon } from '@/services/pay/h5'
import { easyCounterReport } from '@/utils/report'

const RENEWAL_ACT_FRM = 'act_20241223_sogou_pdf_repurchase'
export default {
  components: {
    QrcodeVue,
    DragHeader,
    LoginFromIcon
  },
  props: {
    visible: Boolean,
    payFrom: Number,
    couponConfig: Object,
    paySuccessTip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      qrText: '',
      isExpires: false,
      payType: PAY_CHANNEL.SOGOU,
      hasPay: false,
      isActive: 0,
      // 支付套餐下方文案样式
      tipClass: ['', 'del'],
      couponCheckboxs: [],
      settingsShow: [],
      checked: true,
      qrCodeReportObj: { // 二维码展示上报,字段参考duba_tech_monitor_qrcode表
        action: 1,
        qr_type: 0,
        err_code: ''
      },
      total: 0,
      curSetting: {},
      coupons: [],
      activatedCouponID: 0,
      vip_ex_date_by_add_month: 0,
      realMapToCoupon: {},
      serverTime: 0, // 记录获取支付套餐api的服务器当前时间戳，用于支付中间页查看用户是否已支付api的入参
      certificateId: '', // 中间页支付认证ID
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'openId',
      'loginStatus',
      'isMember',
      'userInfo',
      'isTourist',
      'pdfPermissionVipInfo',
      'continuousInfo',
      'getClientInstallTime'
    ]),
    is_trust () {
      return false
    },
  },
  async created () {
    await this.getPayInfo()
  },
  methods: {
    ...mapActions(['refresh']),
    login () {
      if (this.loginStatus) {
        this.getQrCodeByServer()
        return
      }
      client.common.API.userLogin({ url: LOGIN_SERVICE.url })
    },
    filterDate (timeStamp) {
      if ([1200, 1188].includes(this.curSetting.month_length)) {
        return '永久有效'
      }
      return dateFilter(this.pdfPermissionVipInfo.vip_ex_date + this.curSetting.service_duration_secs)
    },
    getCouponContent (month_length) {
      const ONE_YEAR_MONTH_LENGTH = 12
      const LONG_LIFE_MONTH_LENGTH = 1200
      if (month_length === LONG_LIFE_MONTH_LENGTH) {
        return '终身套餐专属'
      }
      return month_length >= ONE_YEAR_MONTH_LENGTH ? `${Math.ceil(month_length / ONE_YEAR_MONTH_LENGTH)}年套餐专属` : `${month_lengt}月套餐专属`
    },
    selPrice (idx, id, item) {
      this.reportOperate({ sub_mode: this.coupons.length ? this.realMapToCoupon[id] : id })
      this.isActive = idx
      this.curSetting = item
      this.total = item.current_price
      if (this.coupons.length) {
        const activeCoupon = this.coupons.find(coupon => coupon.month_length === item.month_length)
        this.activatedCouponID = activeCoupon.couponID
        this.total = item.current_price - activeCoupon.coupon
      }
      this.getQrCodeByServer(this.coupons.length ? this.realMapToCoupon[id] : id)
    },
    async getPayInfo () {
      this.$route.query.useCoupon ? await this.getUseCouponPayInfo() : await this.getNoCouponPayInfo()
    },
    mapShowIdToCouponId (showPriceSetting, couponPriceSetting) {
      const mapObj = {}
      showPriceSetting.forEach(item => {
        mapObj[item.id] = couponPriceSetting.find(couponItem => couponItem.month_length === item.month_length).id
      })
      this.realMapToCoupon = mapObj
    },
    async getUseCouponPayInfo () {
      const { act_show } = await getCouponConfig({
        frm: RENEWAL_ACT_FRM
      })
      this.coupons = act_show[RENEWAL_ACT_FRM].config.coupons
      const { pay_price_settings } = await getPaySetting({
        is_all: 1,
        show: act_show[RENEWAL_ACT_FRM].config.noCouponShow
      })
      const realCouponRes = await getPaySetting({
        is_all: 1,
        show: act_show[RENEWAL_ACT_FRM].config.useCouponShow
      })
      // 存储服务器当前时间戳
      this.serverTime = realCouponRes.server_time

      this.mapShowIdToCouponId(pay_price_settings, realCouponRes.pay_price_settings)
      this.settingsShow = this.useCouponSetting = pay_price_settings
      this.curSetting = this.settingsShow[this.isActive]
      this.reportOperate({ main_click: 77, sub_mode: this.realMapToCoupon[this.curSetting.id] })
      const activeCoupon = this.coupons.find(item => item.month_length === this.settingsShow[this.isActive].month_length)
      this.activatedCouponID = activeCoupon.couponID
      this.total = this.curSetting.current_price - activeCoupon.coupon
      this.getQrCodeByServer(this.realMapToCoupon[this.curSetting.id])
    },
    async getNoCouponPayInfo () {
      // 服务端写死107
      const { pay_price_settings, server_time } = await getPaySetting({
        is_all: 1,
        show: [153]
      })
      // 存储服务器当前时间戳
      this.serverTime = server_time

      this.settingsShow = this.noCouponSetting = pay_price_settings
      this.curSetting = this.settingsShow[this.isActive]
      this.total = (this.curSetting && this.curSetting.current_price) || 0
      this.reportOperate({ main_click: 77, sub_mode: this.curSetting.id })
      this.getQrCodeByServer()
    },
    /**
     * 默认使用Cookie获取show_from
     * 极光会员红包挽留活动 未使用优惠券：6403 使用优惠券：6404 主动点击续费VIP： 非6403，6404
     */
    getShowFrom () {
      return Number(Cookie.get('show_from') || 0)
    },

    /* eslint-disable-next-line */
    async getQrCodeByServer (couponId = 0) {
      if (!this.loginStatus || this.isTourist || !this.openId) return
      const show_from = this.getShowFrom()
      this.qrCodeReportObj.qr_type = REPORT_RELATED.qr_type.pay

      const { install_time_sec, install_days } = await this.getClientInstallTime

      const reqData = {
        pay_setting_id: couponId || this.curSetting?.id,
        pay_from: this.payFrom || 0,
        pay_channel: this.payType,
        show_from,
        pay_type: PAY_TYPE.SOGOU_WX_WEB,
        uni_from: UNI_FROM.PDF_PAY,
        install_days,
        is_first_order: this.curSetting?.is_first_order,
        pay_setting_name: this.settingsShow[this.isActive].name,
        pay_setting_price: this.total,

        open_id: this.openId, // 用户openid
        server_id: Cookie.get('svrid') || '',
        uuid: Cookie.get('uuid') || '',
        token: this.token,
        vip_version: Cookie.get('vip_version') || '',
        tid1: this.$TidObj.tid1 || 0,
        tid2: this.$TidObj.tid2 || 0,
        tod1: this.$TidObj.tod1 || 0,
        tod2: this.$TidObj.tod2 || 0,
      }

      this.genH5PayCode(reqData)
    },

    /**
     * 生成h5支付中间页二维码
     * @param {object} paramsObj
     * */
    genH5PayCode (paramsObj) {
      this.isExpires = false
      try {
        const H5Params = {
          common: getCommon(),
          client_extra: {
            payParams: paramsObj,
            common: getCommon()
          },
          permission_setting_id: paramsObj.pay_setting_id
        }
        this.qrCodeLoadedReportFunc(REPORT_RELATED.qr_show.api_begin)
        easyCounterReport('renewal_pay_code_api_begin')

        cacheH5PageReportParams(H5Params).then(async res => {
          if (res.resp_common.ret !== 0) {
            this.isExpires = true
            this.$toast('获取支付二维码异常，稍后请重试')
            return
          }
          this.certificateId = res.certificate
          const url = genMidasPayUrl(res.certificate)
          url && this.renderQrCode(url, '')

          // 过期时间到了后设置二维码过期
          setTimeout(() => {
            this.loopPayResultExpire()
          }, Number(res.expire_sec) * 1000)
        })
      } catch (err) {
        console.log('generate short url error:', err)
        this.$toast('获取支付二维码异常，稍后请重试')
      }
    },

    /**
     * 渲染二维码
     * @param {string} codeUrl
     * @param {string} orderId
     */
    renderQrCode (codeUrl, orderId) {
      this.qrCodeLoadedReportFunc(REPORT_RELATED.qr_show.api_success)
      easyCounterReport('renewal_pay_code_api_success')
      this.qrText = codeUrl
      this.orderId = orderId
      this.renderQrcallback()
      const qrShow = this.qrText ? REPORT_RELATED.qr_show.success : REPORT_RELATED.qr_show.fail
      this.qrCodeLoadedReportFunc(qrShow)
      try {
        this.qrText ? easyCounterReport('renewal_pay_code_show_success') : easyCounterReport('renewal_pay_code_show_fail')
      } catch (e) {
        console.error(' == easyCounterReport error == ', e)
      }
    },

    clickCoupon (coupon, index) {
      if (this.activatedCouponID === coupon.couponID) {
        // 点击当前优惠券->取消点击
        this.activatedCouponID = 0
        this.total = this.curSetting.current_price
        this.getQrCodeByServer()
      } else {
        // 非当前优惠券设置套餐
        this.activatedCouponID = coupon.couponID
        const activeIndex = this.isActive = this.settingsShow.findIndex(item => item.month_length === coupon.month_length)
        this.curSetting = this.settingsShow[activeIndex]
        this.total = this.curSetting.current_price - coupon.coupon
        this.getQrCodeByServer(coupon.couponID)
      }
    },

    qrCodeLoadedReport (qr_show, pay_way = 0) {
      const curObj = {
        url: this.$route.fullPath,
        payid: this.curSetting?.id,
        payid_time: this.curSetting?.month_length,
        payway: pay_way || this.payType,
        show_from: this.getShowFrom(),
        qr_show,
      }
      client.techMonitor.REPORT.fetmReportQrcode(Object.assign({}, curObj, this.qrCodeReportObj))
    },

    qrCodeLoadedReportFunc (qrShow) {
      try {
        const payWayReport = 8
        this.qrCodeLoadedReport(qrShow, payWayReport)
      } catch (error) {
        console.error(' == qrCodeLoadedReportFunc error == ', error)
      }
    },
    qrCodeTypeReport (qr_type) {
      const curObj = {
        url: this.$route.fullPath,
        payid: this.curSetting?.id,
        payid_time: this.curSetting?.month_length,
        payway: 1, // 微信固定报1
        show_from: this.getShowFrom(),
      }
      client.techMonitor.REPORT.fetmReportQrcode(Object.assign({}, curObj, { qr_type }))
    },
    renderQrcallback () {
      this.clearLoopTimer()
      // 支付二维码生成完成，开始轮询支付结果接口
      let hour = 3600
      const time = 3
      this.loopPayResultTimer = setInterval(async () => {
        hour = hour - time
        // 一小时有效期
        if (hour > 0) {
          const data = await getH5PayResult({
            start_timestamp: this.serverTime,
            certificate: this.certificateId
          })
          this.payOfSuccess(data)
        } else {
          this.clearLoopTimer()
          this.isExpires = true
          this.qrCodeReportObj.qr_type = REPORT_RELATED.qr_type.expire
          this.qrCodeLoadedReportFunc(REPORT_RELATED.qr_show.success)
        }
      }, time * 1000)
    },

    /**
     * 获取支付成功后的逻辑处理
     * @param {object} data
     */
    payOfSuccess (data) {
      const result = this.isRenderData(data)

      // 0订单支付成功,7001001为支付失败,7001002未支付,7001003支付关闭,7001005没有此订单
      if (result.data && result.data.status === 0) {
        this.clearLoopTimer()
        // 通知客户端，取消未付费提醒弹泡
        client.common.API.paySuccess({ token: this.token, open_id: this.openId })
        // 支付成功上报 - easyCounter
        easyCounterReport('renewal_pay_code_finish')
        this.paySuccessCallback()
        // 修改local storage，通知主界面刷新
        localStorage.setItem(LS_EVENT.REFRESH_PAGE, JSON.stringify({ now: Date.now() }))
        window.close()
      }
    },

    isRenderData (data) {
      try {
        if (data && data.resp_common && data.resp_common.ret === 0) {
          return data
        }
        this.errerTips()
        return false
      } catch (e) {
        this.errerTips()
        return false
      }
    },

    errerTips () {
      this.$toast('获取支付信息异常')
    },

    paySuccessCallback () {
      this.hasPay = true
      const monthLength = this.curSetting.month_length
      this.$emit('paySuccess')
      // 优先弹传入的支付成功提示
      if (this.paySuccessTip) {
        this.$toast(this.paySuccessTip, { duration: 5000 })
      } else {
        this.$toast(monthLength === 1200 ? '您已充值钻石会员，已荣登真爱榜！' : '支付成功', { duration: 5000 })
      }
    },

    clearLoopTimer () {
      if (this.loopPayResultTimer) clearInterval(this.loopPayResultTimer)
    },
    closeModal () {
      this.reportOperate({ main_click: 78 })
      window.close()
    },
    /** 上报 */
    reportOperate (reportData) {
      console.log(JSON.stringify(reportData))
      const data = Object.assign({}, { main_click: 0, show_from: this.getShowFrom(), sub_mode: 0, user_login: this.loginStatus ? 1 : 2 }, reportData)
      client.home.REPORT.reportHomeOperate(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins.scss';
@import '@/assets/css/sprite-diamond-spring-act.scss';

.new-pay {
  position: relative;
  @mixin pay_price_bg(
    $bg: #fff,
    $bcor: #d9d9d9,
    $hover_bcor: #adc4d9,
    $ac_bcor: #eb5350,
    $ac_shadow: #e8f2fc,
    $span_cor: #333
  ) {
    border-radius: 4px;
    vertical-align: middle;
    height: 90px;
    line-height: 20px;
    background: $bg;
    cursor: pointer;
    border: solid 1px $bcor;
    // cursor: pointer;
    &:hover {
      border: solid 1px $ac_bcor;
    }
    &.active {
      border: solid 1px transparent;
      box-shadow: 0 0 0 2px red;
      height: 86px;
      border-radius: 5px;
      margin-top: 2px;
      background-color: #fffcef;
      .active-hook {
        position: absolute;
        right: -2px;
        bottom: 0px;
        width: 17px;
        height: 17px;
        background: transparent url(~@/assets/images/pay-select.png) no-repeat
        right bottom;
      }
      .current-price {
        padding-top: 7px;
      }
      .time-line {
        font-weight: bold;
      }
    }

    .tit-img {
      position: absolute;
      left: -11px;
      top: -17px;
      width: 157px;
      height: 44px;
    }
    .tit-img-3 {
      position: absolute;
      left: -4px;
      top: -22px;
      height: 29px;
      img {
        height: 100%;
      }
    }
    .tit-img-4 {
      height: 26px;
      position: absolute;
      top: -19px;
      left: -4px;
      img {
        height: 100%;
      }
    }
    .tit-time-limit {
      .time-limit {
        color: #de461e;
        height: 26px;
        width: 112px;
        padding-left: 4px;
        box-sizing: border-box;
        position: absolute;
        left: -4px;
        top: -19px;
        font-size: 12px;
      }
      span {
        display: inline;
        font-size: 12px;
        line-height: 24px;
        color: #de461e;
      }
      .tit {
        line-height: 20px;
      }
      .time-span {
        color: #fff;
        display: inline-block;
        width: 18px;
        text-align: center;
        box-sizing: border-box;
        background: #dc320a;
        border-radius: 2px;
        margin-top: -3px;
        line-height: 16px;
        vertical-align: middle;
        overflow: hidden;
      }
      .time-em {
        display: inline-block;
        width: 8px;
        font-style: normal;
      }
    }
    span {
      &.tit {
        position: absolute;
        float: left;
        color: #fff;
        font-size: 12px;
        height: 26px;
        line-height: 24px;
        top: -19px;
        left: -4px;
      }
      &.tit2 {
        display: inline-block;
        margin-top: 35px;
        font-size: 14px;
        max-height: 18px;
        max-width: 96px;
        overflow: hidden;
      }
      &.tit3 {
        margin: 5px;

        font-size: 14px;
        position: relative;
        del {
          color: #909090;
        }
        &.show-next {
          font-size: 12px;
          line-height: 1;
          margin-top: 0;
          color: #909090;
          margin-top: 2px;
          p {
            margin-top: 5px;
          }
        }
      }
      &.price {
        display: inline-block;
        color: #de461e;
        margin-top: 30px;
        max-width: 96px;
        em {
          font-style: normal;
          font-size: 24px;
          vertical-align: 1px;
        }
        letter-spacing: -1px;
        font-size: 28px;
      }
      display: block;
      color: $span_cor;
    }
  }
  ul {
    margin-left: 11px;
    transition: 0.35s 0s ease;
    display: flex;
    &.scroll-right {
      transform: translateX(-63px);
    }
    li {
      text-align: center;
      position: relative;
      width: 117px;
      & > div {
        @include pay_price_bg;
      }
      .supermebertabshow {
        border: 1px solid rgba(241, 211, 197, 1);
        &.active {
          background: url(~@/assets/images/pay-select-bg.png) no-repeat -1px -2px;
        }
      }
    }
  }
  .bottom {
    position: relative;
    height: 140px;
    width: 642px;
    margin-left: 24px;
    box-sizing: border-box;
    font-size: 12px;
    background: #f4f6fa;
    .pay_type {
      float: left;
      margin-bottom: 12px;
      dt {
        font-size: 16px;
        padding-bottom: 10px;
      }
      dd {
        width: 256px;
      }
      span {
        margin-left: 34px;
        cursor: pointer;
      }
      span:nth-child(1) {
        margin-top: 19px;
        margin-bottom: 10px;
      }
    }
    dt {
      color: #333;
      font-size: 14px;
      margin-bottom: 2px;
      padding-left: 6px;
    }
    dd {
      font-size: 14px;
      color: #8d8e93;
    }
    p {
      padding-left: 6px;
    }
    span.total {
      color: #de461e;
      font-size: 36px;
      margin-left: -4px;
      em {
        font-style: normal;
        font-size: 20px;
        margin-right: -1px;
        vertical-align: 1px;
      }
      .total_off {
        color: #8d8e93;
        font-size: 14px;
      }
      letter-spacing: -1px;
    }
    .ali-total {
      font-size: 48px;
      color: #de461e;
      position: absolute;
      bottom: 41px;
      left: 15px;
      line-height: 1;
    }
    .wechat-guide {
      position: absolute;
      right: 0;
      bottom: -18px;
      z-index: 1;
    }
    .diamond-desc {
      margin: 17px 0 0 14px;
      font-size: 14px;
      color: #545454;
      p {
        margin-bottom: 2px;
        padding-left: 0;
      }
      i {
        width: 4px;
        height: 4px;
        background: rgba(141, 142, 147, 1);
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
      .title {
        font-size: 14px;
        color: #b07400;
        background: #fff1ce;
        border: 1px solid #cba864;
        border-radius: 2px;
        width: 79px;
        height: 13px;
        line-height: 13px;
        padding: 2px;
      }
    }
  }
  .notice {
    color: #8d8e93;
    margin-bottom: 18px;
    height: 16px;
  }
  .dl_total {
    float: left;
    padding-top: 34px;
    dd {
      padding-left: 15px;
    }
  }
  .qrcode {
    float: left;
    color: #8d8e93;
    padding-top: 10px;
    margin-left: 50px;
    text-align: center;
    width: 120px;
    height: 120px;
    position: relative;
    img {
      margin-bottom: 10px;
      cursor: pointer;
    }
    img,
    span {
      display: block;
    }
  }
  .pay_title {
    padding-left: 10px;
    em {
      margin: 0 4px;
      font-style: normal;
      color: #de461e;
    }
  }
  .pay-title-wrap {
    display: flex;
    align-items: center;
    color: #545454;
    font-size: 14px;
    em {
      color: #18c048;
      font-style: normal;
      font-weight: bold;
    }
    .alipay-tit {
      color: #3875f6;
    }
    .doubt-wrap {
      padding: 0 10px 10px 0;
    }
    i {
      margin-left: 6px;
      position: relative;
      top: -2px;
    }
  }
  .pay-list {
    width: 648px;
    height: 98px;
    padding-top: 33px;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
  }
  .pay-item-w {
    margin-bottom: 30px;
  }
  .pay-item {
    width: 206px;
    margin-left: 10px;
    &:first-of-type {
      margin-left: 0px;
    }
    &:last-of-type {
      margin-right: 4px;
    }
  }
  .current-price {
    padding-top: 9px;
    font-size: 28px;
    color: #de461e;
    line-height: 1;
    em {
      font-size: 18px;
      font-style: normal;
    }
  }
  .time-line {
    font-size: 14px;
    color: #545454;
    margin-top: 6px;
    line-height: 1;
  }
  .linear {
    width: 100%;
    position: absolute;
    bottom: 27px;
    height: 1px;
    background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) 10%,
            rgba(157, 157, 157, 0.3) 20%,
            rgba(157, 157, 157, 0.4) 30%,
            rgba(157, 157, 157, 0.5) 40%,
            rgba(157, 157, 157, 0.8) 50%,
            rgba(157, 157, 157, 0.5) 60%,
            rgba(157, 157, 157, 0.4) 70%,
            rgba(157, 157, 157, 0.3) 80%,
            rgba(0, 0, 0, 0) 90%,
            rgba(0, 0, 0, 0) 100%
    );
  }
  .supermebertabshow .linear {
    width: 100%;
    position: absolute;
    bottom: 27px;
    height: 1px;
    background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) 10%,
            rgba(223, 110, 57, 0.3) 20%,
            rgba(223, 110, 57, 0.4) 30%,
            rgba(223, 110, 57, 0.5) 40%,
            rgba(223, 110, 57, 0.8) 50%,
            rgba(223, 110, 57, 0.5) 60%,
            rgba(223, 110, 57, 0.4) 70%,
            rgba(223, 110, 57, 0.3) 80%,
            rgba(0, 0, 0, 0) 90%,
            rgba(0, 0, 0, 0) 100%
    );
  }

  .tip {
    font-size: 14px;
    color: #888;
    line-height: 25px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    &.del {
      text-decoration: line-through;
    }
  }
  .renew {
    padding-left: 24px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #7a7a7a;
    a {
      color: #b07400;
      cursor: pointer;
    }
  }
  .checkbox {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(~@/assets/images/sprite.png) no-repeat;
    background-position: -166px -331px;
    margin-right: 10px;
    position: relative;
    top: 1.5px;
    cursor: pointer;
    &.isActive {
      background-position: -152px -331px;
    }
  }
  .ali-pay {
    position: absolute;
    right: 70px;
    bottom: 26px;
    text-align: center;
    color: #8d8e93;
    font-size: 14px;
    line-height: 1;
    span {
      color: #de461e;
    }
  }
  .pay-btn {
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 100px;
    cursor: pointer;
    color: #11a9eb;
    border: 1px solid #11a9eb;
    border-radius: 5px;
    margin: 0 auto 10px;
    &:hover {
      color: #fff;
      background: #11a9eb;
    }
  }
  .is-disabled {
    color: #cacaca;
    cursor: not-allowed;
    visibility: hidden;
    .checkbox {
      cursor: not-allowed;
      background: url(~@/assets/images/grey-checkbox.png) no-repeat center
      center;
    }
    a {
      color: #cacaca;
      cursor: not-allowed;
    }
  }
}
.pay-item-w {
  margin-bottom: 30px;
}
.pay-item {
  margin-left: 13px;

  &:last-of-type {
    margin-right: 4px;
  }
}
.current-price {
  padding-top: 9px;
  font-size: 28px;
  color: #de461e;
  line-height: 1;
  em {
    font-size: 18px;
    font-style: normal;
  }
}
.time-line {
  font-size: 14px;
  color: #545454;
  margin-top: 6px;
  line-height: 1;
}
.linear {
  width: 100%;
  position: absolute;
  bottom: 27px;
  height: 1px;
  background: linear-gradient(
          to right,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) 10%,
          rgba(157, 157, 157, 0.3) 20%,
          rgba(157, 157, 157, 0.4) 30%,
          rgba(157, 157, 157, 0.5) 40%,
          rgba(157, 157, 157, 0.8) 50%,
          rgba(157, 157, 157, 0.5) 60%,
          rgba(157, 157, 157, 0.4) 70%,
          rgba(157, 157, 157, 0.3) 80%,
          rgba(0, 0, 0, 0) 90%,
          rgba(0, 0, 0, 0) 100%
  );
}
.tip {
  font-size: 14px;
  color: #888;
  line-height: 25px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  &.del {
    text-decoration: line-through;
  }
}
.pop-wrap {
  width:688px;
  height:490px;
  background-color: #fff;
  .close-btn-wrap {
    position: absolute;
    top: 3px;
    right: 3px;
    width: 24px;
    height: 24px;
    overflow: hidden;
    cursor: pointer;
    z-index: 10;
    .close-btn {
      position: relative;
      &:hover {
        left: -24px;
      }
      &:active {
        left: -48px;
      }
    }
  }
  .act-hd {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 8px;
    line-height: 30px;
    color: #fce2ac;
    font-size:12px;
    .logo {
      margin-right: 4px;
    }
    .sprite-icon-home-logo {
      padding-bottom: 2px;
    }
  }
  .act-bd {
    padding: 20px;
    color: #545454;
    font-size: 12px;
    .item {
      margin-bottom: 15px;
      display: flex;
      flex: 1;
    }

    .account-item {
      height: 14px;
      line-height: 14px;
      color: #333;
    }

    .pay-setting-item {
      display: flex;
      flex: 1;
      .item-rt {
        display: flex;
        flex: 1;
        justify-content: space-between;
      }
    }

    .coupon-item {
      .item-rt {
        position: relative;
        width:430px;
        height:47px;
        box-sizing: border-box;
        border: 2px solid #F10000;
        border-radius: 4px;
        line-height: 47px;
        text-indent: 35px;
        font-size:16px;
        cursor: pointer;
        em {
          color: #f10000;
          font-style: normal;
        }
        .coupon-recommend {
          position: absolute;
          top: 0;
          left: 0;
        }
        .coupon-select {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .no-coupon-rt {
        border: 1px solid #D9D9D9;
      }
    }

    .qrcode-item {
      .item-rt {
        display: flex;
        flex: 1;
        align-items: center;
        height:128px;
        box-sizing: border-box;
        padding: 9px 11px;
        background-color: #F4F6FA;
        .qrcode {
          img {
            width: 110px;
            height: 110px;
          }
          margin-right: 27px;
        }
        .current-price {
          font-size: 41px;
          color: #f10000;
          em {
            font-size: 14px;
            font-style: normal;
          }
        }
        .pay-title {
          em {
            color: #f10000;
            font-style: normal;
          }
        }
      }
    }

  }
}
.btn_close {
  position: absolute;
  right: 0px;
  top: 2px;
  -webkit-app-region: no-drag;
  display: inline-block;
  vertical-align: middle;
  z-index: 3;
  @include icon_bg;
  width: 26px;
  height: 26px;
  background-position: -5px -262px;
  cursor: pointer;
  &:hover {
    background-position: -29px -262px;
  }
}
.title {
  display: inline-block;
  color: rgba(176, 116, 0, 1);
  font-size: 12px;
  padding-left:5px;
}
.coupon-list {
  margin: 7px 3px 7px 0px;
  display: flex;
  justify-content: space-around;

  .coupon-item {
    width: 200px;
    height: 60px;
    background: url(./_images/coupon-bg-unselected.png);
    display: flex;
    cursor: pointer;

    &.active {
      background: url(./_images/coupon-bg-selected.png);
    }
  }

  .coupon-left,
  .coupon-right {
    width: 50%;
  }

  .coupon-left {
    font-size: 40px;
    line-height: 60px;
    text-align: center;
    color: #ffffff;
    text-shadow: 0px 0px 3px #cb6c33;

    .coupon-price {
      position: relative;
      left: -7px;
    }

    .coupon-unit {
      position: absolute;
      bottom: 7px;
      right: -13px;
    }
  }

  .coupon-right {
    font-size: 14px;
    color: #ffefe3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.name-style{
  padding: 0 2px 0 0;
}
.pay_type {
  display: flex;
  align-self: flex-start;
  display: flex;
  align-self: flex-start;
  margin: -8px 0 0 -10px;

  dt {
    font-size: 16px;
    padding-bottom: 10px;
  }

  dd {
    width: 200px;
  }
}
</style>
